export const REGISTRATION_STATUS_ACTIVE = 'ACTV';
